import { useFormik } from 'formik';
import React from 'react';
import { useState } from 'react';
import { BookButton, BookModal, BookTexField } from '../../components';
import { usersValidation } from '../Users/validation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CreateUser, UpdateUser } from "../../DAL/users/users";
import { enqueueSnackbar } from "notistack";

const UsersModal = ({
    open,
    setOpen,
    action,
    singleUser,
    tableCells,
    handleGetUsers,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.up('sm'));

    const handleAddUser = async (values) => {
        setIsLoading(true);
        const data = {
            name: values?.name,
            email: values?.email,
            password: values?.password,
            role: values?.role
        };
        const response = await CreateUser(data);
        if (response.statusCode == 200) {
            setIsLoading(false);
            handleGetUsers()
            setOpen(false);
            formik.handleReset();
        } else {
            setIsLoading(false);
            if (typeof response.message == "string") {
                enqueueSnackbar(response.message, { variant: "error" });
            } else {
                enqueueSnackbar("Invalid credentials", { variant: "error" });
            }
        }
    };

    const handleUpdateUser = async (values) => {
        setIsLoading(true);
        const data = {
            name: values?.name,
            email: values?.email,
            password: values?.password,
            role: values?.role
        };
        const response = await UpdateUser(values?.id, data);
        if (response.statusCode == 200) {
            setIsLoading(false);
            handleGetUsers()
            setOpen(false);
            formik.handleReset();
        } else {
            setIsLoading(false);
            if (typeof response.message == "string") {
                enqueueSnackbar(response.message, { variant: "error" });
            } else {
                enqueueSnackbar("Invalid credentials", { variant: "error" });
            }
        }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            id:
                action !== 'add' && singleUser && singleUser.id
                    ? singleUser.id
                    : '',
            name:
                action !== 'add' && singleUser && singleUser.name
                    ? singleUser.name
                    : '',
            email:
                action !== 'add' && singleUser && singleUser.email
                    ? singleUser.email
                    : '',
            password:
                action !== 'add' && singleUser && singleUser.password
                    ? singleUser.password
                    : '',
            role:
                action !== 'add' && singleUser && singleUser.role
                    ? singleUser.role
                    : '',
        },
        validationSchema: usersValidation,
        onSubmit: values => {
            setIsLoading(true);
            if (action === 'add') {
                handleAddUser(values);
            } else {
                handleUpdateUser(values);
            }
        },
    });

    return (
        <BookModal
            open={open}
            formik={formik}
            setOpen={setOpen}
            title='User'
            subtitle={`${action === 'add' ? 'Add' : 'Edit'} User`}
        >
            {tableCells &&
                tableCells.map(
                    t =>
                        t.id !== 'actions' &&
                        (t.id === 'role' ? (
                            <BookTexField
                                formik={formik}
                                name={t.id}
                                label={t.title}
                                placeholder={`Enter ${t.title}`}
                                key={t.id + 'cell'}
                                select={true}
                                selectOptions={[{text: "Admin", value: "admin"}, {text: "Content Creator", value: "content_creator"}]}
                            />
                        ) : (
                            <BookTexField
                                formik={formik}
                                name={t.id}
                                type={t?.type ? t?.type : 'text'}
                                label={t.title}
                                placeholder={`Enter ${t.title}`}
                                key={t.id + 'cell'}
                            />
                        ))
                )}
            <BookButton
                onSubmit={formik.handleSubmit}
                title={`${action === 'add' ? 'Add' : 'Update'}`}
                type='primary'
                variant='contained'
                isLoading={isLoading}
                sx={{
                    top: '0.625rem',
                    marginBottom: '0.625rem'
                }}
            />
        </BookModal>
    );
};

export default UsersModal;

